import { Mutable } from '@skylab-shared/types';
import { RuleDefinition } from '../rules-engine';

export const mergeDefinitions = <TRuleArgs>(
    target: Mutable<RuleDefinition<TRuleArgs>>,
    ruleDefinition: RuleDefinition<TRuleArgs>
): void => {
    const prevFuncAsync = target.rule.funcAsync;
    const prevFunc = target.rule.func;
    target.triggeredBy = [...target.triggeredBy, ...ruleDefinition.triggeredBy];
    target.rule = {
        funcAsync: (...args) => prevFuncAsync(...args)
            .then(result => result ? result : ruleDefinition.rule.funcAsync(...args)),
        func: (...args) => prevFunc(...args) || ruleDefinition.rule.func(...args)
    };
};
